<div class="row justify-content-center  full-hight login">

  <div class=" row justify-content-center">
    <div class="col-8">
      <h1 class="titleBookk">{{ 'LOSTPASSWORD.TITLE' | translate }}</h1>
    </div>
    <div class="col-10">
      <p class="main-text">{{ 'LOSTPASSWORD.TEXT1' | translate }}</p>
      <p class="main-text">{{ 'LOSTPASSWORD.TEXT2' | translate }}</p>
      <p class="main-text">{{ 'LOSTPASSWORD.TEXT3' | translate }}</p>
    </div>
    <div class="col-10 mt-3">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="form-group row">
            <h3 for="login" class="col-sm-4 col-form-label main-input">{{ 'LOSTPASSWORD.LOGIN' | translate }} : </h3>
            <div class="col-sm-12 col-md-5">
              <input type="text" class="form-control main-input" id="login" [(ngModel)]="username" #ctrl="ngModel">
            </div>
          </div>
        </div>
        <!-- <div class="col-12">
          <div class="form-group row">
            <h3 for="inputEmail" class="col-sm-4 col-form-label main-input">{{ 'LOSTPASSWORD.EMAIL' | translate }} :</h3>
            <div class="col-sm-12 col-md-5">
              <input type="email" class="form-control main-input" id="inputEmail" [(ngModel)]="email" #ctrl="ngModel">
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div *ngIf="error" class="col-sm-8">
      <div class="row  justify-content-center error-space">
          <div class="col-10" >
              <p class="main-text error clem-font autopartage">Votre nom d'utilisateur et/ou e-mail est incorrect, veuillez réessayer</p>
            </div>
      </div>
    </div>
      <div class="col-sm-8">
        <div class="row justify-content-around">
          <div class="col-sm-5 col-10 mt-4 mt-sm-1 order-2 order-sm-1">
            <a href="#"><button mat-flat-button color="primary" class="full-width main-button">{{ 'LOSTPASSWORD.RETOUR' | translate }}</button></a>
          </div>
          <div class="col-sm-5 col-10 mt-4 mt-sm-1 order-1 order-sm-2">
            <button mat-flat-button color="primary" class="full-width main-button" (click)='sendData()'>{{ 'LOSTPASSWORD.VALIDER' | translate }}</button>
          </div>

        </div>

      <!-- <div class="row">



      <mat-form-field class=" col-sm-12" appearance="outline">
        <mat-label>Nom d'utilisateur</mat-label>
        <input matInput placeholder="Nom d'utilisateur" [(ngModel)]="username" #ctrl="ngModel">
        <mat-error *ngIf="false">
          Nom d'utilisateur <strong>requis</strong>
        </mat-error>
      </mat-form-field>
      <mat-form-field class=" col-sm-12" appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput type="email" placeholder="Email" [(ngModel)]="email" #ctrl="ngModel">
      </mat-form-field> 


    </div> -->
    </div>

      <div class="col-10 mt-5">
          <p class="main-text link-style" [matTooltip]="'LOSTPASSWORD.TOOLTIP' | translate">
              {{ 'LOSTPASSWORD.TEXT5' | translate }}
          </p>
      </div>

  </div>
